import { Spinner } from "./spinner";
import { cn } from "../lib/utils";

interface FullscreenLoaderProps {
  logo?: string;
  logoClassName?: string;
  spinnerClassName?: string;
}

export function FullscreenLoader({
  logo,
  logoClassName,
  spinnerClassName,
}: FullscreenLoaderProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background">
      <div className="flex flex-col items-center gap-6">
        {logo && (
          <img src={logo} alt="Logo" className={cn("h-14", logoClassName)} />
        )}
        <Spinner
          className={cn(
            "size-10 text-brand-dark-orange animate-spin",
            spinnerClassName,
          )}
        />
      </div>
    </div>
  );
}
